<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title"><span translate>ADD_NEW_MFA</span></h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="mfa-code-container">
    <span translate>SECURE_MFA_MESSAGE</span>

    <div>
      <span class="small" translate>RECOMMENDED_APPS</span>:
      <ul class="small">
        <li>
          Windows:
          <a href="https://www.microsoft.com/en-us/security/mobile-authenticator-app" target="_blank"
            >Microsoft Authenticator</a
          >
        </li>
        <li>
          Cross-platform:
          <a href="https://support.google.com/accounts/answer/1066447" target="_blank">Google Authenticator</a>
        </li>
      </ul>
    </div>

    <div class="my-4">
      <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code" class="mfa-code-img" />
    </div>

    <span translate>SETUP_WITH_APP_ON_THIS_MACHINE</span>

    <span class="mt-3" translate>SECURE_MFA_INSTRUCTIONS</span>

    <div class="mt-3">
      <div class="setup-code-form" [formGroup]="form">
        <div class="form-group">
          <lib-gung-text-input
            gungTranslate="DEVICE_NAME"
            formControlName="deviceName"
            placeholder="{{ 'e.g. Work iPhone' | translate }}"
          ></lib-gung-text-input>
          <lib-forms-message-error [controller]="form.get('deviceName')"></lib-forms-message-error>
        </div>

        <div class="form-group">
          <lib-gung-text-input
            gungTranslate="VERIFY_CODE"
            formControlName="code"
            placeholder="{{ 'Enter 6-digit code' | translate }}"
            maxlength="6"
          ></lib-gung-text-input>
          <lib-forms-message-error [controller]="form.get('code')"></lib-forms-message-error>
        </div>
      </div>
    </div>

    <div *ngIf="invalidSetupCode" class="alert alert-danger mt-2" translate>INVALIDE_MFA_CODE</div>

    <p class="small mt-3" translate>SECURE_MFA_NOTE</p>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-default btn-border-primary" translate (click)="close()">CANCEL</button>
  <button type="button" class="btn btn-sm btn-default btn-primary" translate (click)="add()">ADD</button>
</div>
